import React from 'react';


import component, {classnames} from './component';
import {CursorInput} from './Form';
import Link from './Link';
import {Magnifier} from './icons';


export default component('SearchBar', function({className, data, placeholder, onSubmit}) {

  const submit = (e) => {
    e.preventDefault();
    onSubmit && onSubmit();
  };

  return <div className={classnames(className, 'SearchBar')}>
    <form onSubmit={submit}>
      <div className='SearchBar-Magnifier'>
        <Magnifier />
      </div>
      <CursorInput value={data} type='text' placeholder={placeholder}
                   className='SearchBar-Input' />
    </form>
  </div>;
});



// WEBPACK FOOTER //
// ./src/components/SearchBar.js